// ** Redux & Store & Actions
import { memo, useContext } from "react";
import { useSelector } from "react-redux";

// ** Third Party Components
import loadable from "@loadable/component";
import withHydrationOnDemand from "react-hydration-on-demand";

// ** Custom Components
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardBody } from "components/layout/Card/CardBody";

const UsersViewGrid = memo(
	loadable(() => import("./UsersViews/UsersViewGrid"), { ssr: false })
);
const UsersViewList = memo(
	loadable(() => import("./UsersViews/UsersViewList"))
);
const UsersViewListWithHydrationOnDemand = withHydrationOnDemand({
	on: ["idle"],
	onBefore: UsersViewList.load,
})(UsersViewList);

// ** Custom Hooks
import useProcessedUsersList from "../hooks/useProcessedUsersList";

// ** Context
import AuthContext from "contexts/authContext";

// #####################################################

const UsersList = ({
	isChangingFilter,
	triggerRef,
	containerRef,
	viewType,
}) => {
	const usersListData = useSelector((state) => state.mainPageUsers.data);
	const usersLoading = useSelector((state) => state.mainPageUsers.loading);
	const usersLoaded = useSelector((state) => state.mainPageUsers.loaded);
	const usersPagination = useSelector(
		(state) => state.mainPageUsers.pagination
	);

	const isAuth = useContext(AuthContext);

	const userListDataFinal = useProcessedUsersList({
		usersListData,
		isAuth,
	});

	// #####################################################

	if (isAuth && viewType === "grid") {
		return (
			<CardWrapper ref={containerRef}>
				<CardBody>
					<UsersViewGrid
						isLoading={usersLoading}
						isLoaded={usersLoaded}
						data={usersListData}
						pagination={usersPagination}
						isChangingFilter={isChangingFilter}
						triggerRef={triggerRef}
					/>
				</CardBody>
			</CardWrapper>
		);
	}

	return (
		<UsersViewListWithHydrationOnDemand
			containerRef={containerRef}
			isLoading={usersLoading}
			isLoaded={usersLoaded}
			data={userListDataFinal}
			pagination={usersPagination}
			isChangingFilter={isChangingFilter}
			triggerRef={triggerRef}
		/>
	);
};

// #####################################################

export default UsersList;

// #####################################################
